import { Box, Paper, Stack, TextField, Typography } from '@mui/material';
import { memo } from 'react';
import {
  BADGE_SX,
  READ_ONLY_FIELD_SX,
  SURFACE_SX,
  formatValue,
} from './customerDetailUtils';

const CustomerDetailFortnoxCard = memo(function CustomerDetailFortnoxCard({ customer }) {
  return (
    <Paper elevation={0} sx={{ ...SURFACE_SX, p: { xs: 2, md: 2.25 } }}>
      <Stack spacing={1.5}>
        <Box>
          <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
            <Typography variant="h6" fontWeight={700}>
              Fortnox customer data
            </Typography>
            <Box
              component="span"
              sx={{
                ...BADGE_SX,
                color: 'text.secondary',
                backgroundColor: 'rgba(0,0,0,0.04)',
                borderColor: 'rgba(0,0,0,0.08)',
              }}
            >
              Read only
            </Box>
          </Stack>
          <Typography variant="body2" color="text.secondary">
            Master customer fields stay sourced from Fortnox and cannot be edited here.
          </Typography>
        </Box>

        <TextField
          label="Customer number"
          value={formatValue(customer?.customerNumber, '')}
          size="small"
          InputProps={{ readOnly: true }}
          sx={READ_ONLY_FIELD_SX}
          fullWidth
        />
        <TextField
          label="Name"
          value={formatValue(customer?.name, '')}
          size="small"
          InputProps={{ readOnly: true }}
          sx={READ_ONLY_FIELD_SX}
          fullWidth
        />
        <TextField
          label="Address line 1"
          value={formatValue(customer?.address1, '')}
          size="small"
          InputProps={{ readOnly: true }}
          sx={READ_ONLY_FIELD_SX}
          fullWidth
        />
        <TextField
          label="Address line 2"
          value={formatValue(customer?.address2, '')}
          size="small"
          InputProps={{ readOnly: true }}
          sx={READ_ONLY_FIELD_SX}
          fullWidth
        />

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'repeat(2, minmax(0, 1fr))' },
            gap: 1.25,
          }}
        >
          <TextField
            label="City"
            value={formatValue(customer?.city, '')}
            size="small"
            InputProps={{ readOnly: true }}
            sx={READ_ONLY_FIELD_SX}
            fullWidth
          />
          <TextField
            label="Zip code"
            value={formatValue(customer?.zipCode, '')}
            size="small"
            InputProps={{ readOnly: true }}
            sx={READ_ONLY_FIELD_SX}
            fullWidth
          />
          <TextField
            label="Phone"
            value={formatValue(customer?.phone, '')}
            size="small"
            InputProps={{ readOnly: true }}
            sx={READ_ONLY_FIELD_SX}
            fullWidth
          />
          <TextField
            label="Email"
            value={formatValue(customer?.email, '')}
            size="small"
            InputProps={{ readOnly: true }}
            sx={READ_ONLY_FIELD_SX}
            fullWidth
          />
        </Box>

        <TextField
          label="Organisation number"
          value={formatValue(customer?.organisationNumber, '')}
          size="small"
          InputProps={{ readOnly: true }}
          sx={READ_ONLY_FIELD_SX}
          fullWidth
        />
      </Stack>
    </Paper>
  );
});

export default CustomerDetailFortnoxCard;
